import { Component, inject, OnInit } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { FactorService } from 'src/app/factors/services/factor.service';
import {
  CategoryItem,
  CategorySelectorComponent,
} from '../../../custom-input/category-selector/category-selector.component';
import { TransportFormService } from 'src/app/trip-calculator/services/transport-form.service';

@Component({
  selector: 'app-select-custom-transport-factor',
  imports: [TranslocoPipe, CategorySelectorComponent],
  templateUrl: './select-custom-transport-factor.component.html',
})
export class SelectCustomTransportFactorComponent implements OnInit {
  transportFormService = inject(TransportFormService);

  factorService = inject(FactorService);

  items: CategoryItem[] = [];

  ngOnInit() {
    this.initializeItems();
  }


  initializeItems() {
    this.items = [];
    for (const factor of this.transportFormService.transportFactor()) {
      this.items.push({
        value: factor.id,
        label: factor.name,
      });
    }
  }

  get value() {
    const value = this.transportFormService.transportForm.get(
      'customEmissionFactorId',
    )?.value;
    return value ? value : '';
  }

  set value(value: string) {
    this.transportFormService.transportForm
      .get('customEmissionFactorId')
      ?.setValue(value);
  }
}
